import { Client } from '@stomp/stompjs'

import { WEBSOCKET_URL } from '../api/constants/authRoutes'

export const socketClient = new Client({

    brokerURL: WEBSOCKET_URL,

    reconnectDelay: 5000,

    heartbeatIncoming: 4000,

    heartbeatOutgoing: 4000,

    debug: () => {
        // opcional
    }
})